import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_ADMIN, ROLE_RENTER } from '../../constants/roles';

const VouchersApiService = {

  getVouchers(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/vouchers`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postVoucher(token, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_RENTER)}/vouchers`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putVoucher(token, voucherId, data) {
    return axios
      .put(`${getBackOfficeRoute(ROLE_RENTER)}/vouchers/${voucherId}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  deleteVoucher(token, voucherId) {
    return axios
      .delete(`${getBackOfficeRoute(ROLE_ADMIN)}/vouchers/${voucherId}`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default VouchersApiService;



// WEBPACK FOOTER //
// ./src/services/api/VouchersApiService.js